import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import io from 'socket.io-client';
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
// import Timer from 'react-timer-wrapper';
import moment from 'moment';
// import { isMobile } from 'react-device-detect';
// import { loadTossPayments } from '@tosspayments/payment-sdk';
import '../css/yemae.css';
import QRCode from 'react-qr-code';
import { useIsMobile } from '../hooks/useIsMobile';

// import usePaging from '../hooks/usePaging';

// const socket = io('http://son.aniplustv.com:4000');
const pageingState = {
  gotoPage: 1,
  pageCount: 0,
  con: 0,
};
const SeatReserveList = (props) => {
  const { apiUrl, loginId, pkg, nicName, icon } = props;
  const {
    gPage,
    setGPage,
    showSeat,
    ticketCode,
    charImg,
    cnt,
    param,
    setCnt,
    setParam,
    popupClose,
    socket,
  } = props.childProps;

  const pageSize = 3;
  const [gotoPage, setGotoPage] = useState(gPage);
  // const [cnt, setCnt] = useState(0);
  // const [param, setParam] = useState('');
  const [con, setCon] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [list, setList] = useState([]);
  const [orderCode, setOrderCode] = useState('');
  const [page, setPage] = useState(pageingState);
  const isMobile = useIsMobile();
  const _getData = async (gotoPage) => {
    const result = await axios.post(`${apiUrl}/seatReserveMyList`, {
      userid: loginId,
      pkg,
      ticketCode,
      gotoPage,
      pageSize,
    });

    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
      setCnt(result.data[0].cnt);
      setParam(result.data[0].param);
      setCon(result.data[0].con);
      setPageCount(result.data[0].pageCount);
      setList(result.data[0].listData);
      setPage({
        ...page,
        gotoPage: gotoPage,
        con: result.data[0].con,
        pageCount: result.data[0].pageCount,
      });
      setGPage(gotoPage);
    } else {
      setList([]);
    }
  };

  const _reserveCancel = async (orderCode, ticketCode) => {
    const chkConfirm = window.confirm(
      '결제건의 티켓 예매내역을 모두 취소하시겠습니까?\n\n취소된 내역은 복구되지 않으니 신중하게 결제를 취소해 주세요!'
    );
    if (chkConfirm) {
      const result = await axios.post(`${apiUrl}/seatReserveCancel`, {
        orderCode,
        ticketCode,
        userid: loginId,
        pkg,
      });

      const intReturn = result.data[0].intReturn;
      const listData = result.data[0].listData;

      if (intReturn === 0) {
        const rtime = listData[0].rtime;
        // console.log(rtime);
        let socket;
        if (rtime === '1000') {
          socket = io('https://ticket1.aniplustv.com');
          // socket = io('https://ticket1.aniplustv.com');
        } else if (rtime === '1245') {
          socket = io('https://ticket2.aniplustv.com');
        } else if (rtime === '1520') {
          // socket = io('https://ticket3.aniplustv.com');
        }
        // const roomName = listData[0].rdate.toString() + listData[0].rtime.toString() + listData[0].room.toString();
        const data = {
          orderCode: orderCode,
          userid: loginId,
        };
        /*소켓 처리*/

        socket.emit('reserveCancel', data);
        setTimeout(() => {
          alert('정상적으로 예매가 취소되었습니다.');
          _getData(1);
        }, 500);
      } else if (intReturn === -1) {
        alert('취소일자가 지난 결제 또는 취소가 불가능한 결제 내역입니다.');
      } else if (intReturn === -2) {
        alert('취소중 오류가 발생했습니다.');
      } else if (intReturn === -100) {
        alert('회원정보를 확인해 주세요');
      } else if (intReturn === -100) {
        alert('PG사 취소에 실패했습니다.\n\n관리자에게 문의해 주세요.');
      } else {
        alert('기타 오류가 발생했습니다.\n\n관리자에게 문의해 주세요.');
      }
    }
  };
  const _ReanerPage = () => {
    const { gotoPage, con, pageCount } = page;
    const dataPerPage = 3;
    // console.log(gotoPage, con, pageCount);
    let pageCount1;

    if (pageCount > dataPerPage) {
      pageCount1 = dataPerPage;
    } else {
      pageCount1 = pageCount;
    }
    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수

    const pageGroup = Math.ceil(gotoPage / pageCount1); //페이지 그룹
    let last = pageGroup * pageCount1;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount1 - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount1) {
    } else {
    }

    if (next > pageCount1 && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }
    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          className={gotoPage === num ? 'on' : null}
          onClick={() => _getData(num)}
        >
          {num}
        </span>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return <>{list}</>;
  };
  const getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  useEffect(() => {
    _getData(gotoPage);
  }, [gotoPage]);

  return (
    <div className="gumaenaeyeog_page">
      <div className="float_left">
        <div className="left_title_text">티켓구매내역</div>
        <div className="pop_user">
          <dl>
            <dt>
              <img src={getCookie('ic')} />
            </dt>
            <dd>
              {nicName}
              <br />
              (총 {cnt}건)
            </dd>
          </dl>
        </div>
        <div className="bagkodeu_div">
          {list.length > 0 ? (
            <QRCode
              style={{ width: '80%' }}
              value={`https://t.aniplustv.com:4000/u/${list[0].qrcodeUrl}`}
            />
          ) : null}
        </div>
        <div className="left_bg2">
          주문번호를 클릭하시면
          <br />
          상세내역을 확인하실 수 있습니다
        </div>
      </div>
      <div className="float_right">
        <div className="right_padding">
          <div className="info-title">
            주문번호를 클릭하시면 좌석을 확인하실 수 있습니다.
          </div>
          {isMobile ? (
            <>
              {list.length > 0
                ? list.map((item) => (
                    <div className="pop_list_table">
                      <div className="table-title">주문번호</div>
                      <div
                        className="table-value-order"
                        onClick={() => showSeat(item.orderCode)}
                      >
                        {item.orderCode}
                      </div>
                      {/* <div className="table-title">티켓명</div> */}
                      <div className="table-value">{item.title}</div>
                      <div className="table-value">
                        구매단가: {item.ticketEaPrice.toLocaleString('ko-KR')}
                      </div>
                      <div className="table-value">
                        구매갯수: {item.ticketCount}
                      </div>
                      <div className="table-value">
                        구매단가: {item.ticketPrice.toLocaleString('ko-KR')}
                      </div>
                      {item.cancelStartDate <=
                        moment(new Date()).format('YYYY-MM-DD HH:mm:ss') &&
                      item.cancelEndDate >=
                        moment(new Date()).format('YYYY-MM-DD HH:mm:ss') ? (
                        <div
                          className="table-cancel"
                          onClick={() => {
                            _reserveCancel(item.orderCode, item.ticketCode);
                          }}
                        >
                          {item.cancel ? '취소완료' : '취소하기'}
                        </div>
                      ) : null}
                    </div>
                  ))
                : null}
            </>
          ) : (
            <table
              width="100%"
              border="0"
              cellSpacing="0"
              cellPadding="0"
              className="pop_list_table"
            >
              <colgroup>
                <col width="50px" />
                <col width="" />
                <col width="50px" />
                <col width="50px" />
                <col width="50px" />
                <col width="50px" />
              </colgroup>
              <thead>
                <tr>
                  <th>주문번호</th>
                  <th> 티켓명 </th>
                  <th>구매단가</th>
                  <th>구매갯수</th>
                  <th>총구매금액</th>
                  <th>취소</th>
                </tr>
              </thead>
              <tbody>
                {list.length > 0 ? (
                  list.map((item) => (
                    <tr key={item.orderCode}>
                      <td
                        className="btnOrderCode"
                        style={{ cursor: 'pointer' }}
                        onClick={() => showSeat(item.orderCode)}
                      >
                        {item.orderCode}
                      </td>
                      <td>{item.title}</td>
                      <td>{item.ticketEaPrice.toLocaleString('ko-KR')}</td>
                      <td>{item.ticketCount}</td>
                      <td>{item.ticketPrice.toLocaleString('ko-KR')}</td>
                      <td>
                        {moment(item.cancelStartDate).format(
                          'YYYY-MM-DD HH:mm:ss'
                        ) <= moment(new Date()).format('YYYY-MM-DD HH:mm:ss') &&
                        moment(item.cancelEndDate).format(
                          'YYYY-MM-DD HH:mm:ss'
                        ) >=
                          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') ? (
                          <a
                            onClick={() => {
                              _reserveCancel(item.orderCode, item.ticketCode);
                            }}
                          >
                            {item.cancel ? '취소완료' : '취소하기'}
                          </a>
                        ) : (
                          <a
                            onClick={() => {
                              _reserveCancel(item.orderCode, item.ticketCode);
                            }}
                          >
                            {item.cancel ? '취소완료' : '취소하기'}
                          </a>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">예매 내역이 존재하지 않습니다.</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}

          <div className="page_no1">
            <_ReanerPage />
            {/* <span>1</span>
            <span>2</span>
            <span>3</span> */}
          </div>
        </div>
      </div>
      <div style={{ clear: 'both' }}></div>
      <div className="gumaenaeyeog_pop_close" onClick={popupClose}>
        <span>닫기</span>
      </div>
    </div>
  );
};
export default shopContext(withRouter(SeatReserveList));
